module.exports = __webpack_public_path__ + "static/media/simaset.c1e50fbc.png";